module.exports = __webpack_public_path__ + "img/step42_a_tea_the_plastic.d094788c.png";